// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const pastPaperApi = createApi({
  reducerPath: "pastPaperApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getPastPaper", "getPackage"],
  endpoints: (builder) => ({
    getPastPaper: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getPastPaper"],
    }),
    getPastPaperPackage: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getPackage"],
    }),

    createPackage: builder.mutation({
      query: ({ endpoint, newPackage }) => {
        return {
          url: endpoint,
          method: "POST",
          body: newPackage,

        };
      },
      invalidatesTags: ["getPackage"],
    }),

    createPastPaper: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,

        };
      },
      invalidatesTags: ["getPastPaper"],
    }),
    updatePastPaper: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
      invalidatesTags: ["getPastPaper"],
    }),
    getPastPaperAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
  }),
});

export const {
  useGetPastPaperPackageQuery,
  useGetPastPaperQuery,
  useGetPastPaperAnalyticsQuery,
  useCreatePackageMutation,
  useCreatePastPaperMutation,
  useUpdatePastPaperMutation,
  useLazyGetPastPaperQuery
} = pastPaperApi;
